import classNames from 'classnames'
import { ICON_AIRPLANE, ICON_LOCKED_GOAL, ICON_UNLOCKED_GOAL } from '../../../../../modules/images'

interface ProgressbarProps {
  progress: number
  width?: string
}

const Progressbar = ({ progress, width = '96%' }: ProgressbarProps) => {
  const limitedProgress = Math.min(100, Math.max(0, progress))
  const isCompleted = progress >= 100

  const progressColor = isCompleted ? 'bg-red-300' : 'bg-purple-300'
  const goalImage = isCompleted ? ICON_UNLOCKED_GOAL : ICON_LOCKED_GOAL

  return (
    <div className="h-40 flex items-center">
      <div className="relative h-16 bg-gray-200 rounded-full" style={{ width }}>
        <div
          className={classNames('absolute left-0 h-full rounded-l-full', progressColor)}
          style={{
            width: `${limitedProgress}%`,
            transition: 'width 1.0s ease-in-out',
          }}
        />
        <div className="absolute top-1/2 -translate-y-1/2 left-1/4 border-[2.5px] border-white h-full w-16 rounded-full" />
        <div className="absolute top-1/2 -translate-y-1/2 left-2/4 border-[2.5px] border-white h-full w-16 rounded-full" />
        <div className="absolute top-1/2 -translate-y-1/2 left-3/4 border-[2.5px] border-white h-full w-16 rounded-full" />

        <div
          className={classNames('absolute top-1/2 -translate-y-1/2', {
            '-translate-x-[20%]': progress < 1,
            '-translate-x-[40%]': progress >= 1,
            hidden: isCompleted,
          })}
          style={{
            left: `${limitedProgress}%`,
            transition: 'left 1.0s ease-in-out',
          }}
        >
          <img src={ICON_AIRPLANE} alt="air-plan" height={40} width={40} />
        </div>

        <div className="absolute top-1/2 -translate-y-1/2 right-0 translate-x-[80%]">
          <img src={goalImage} alt="goal" height={40} width={40} />
        </div>
      </div>
    </div>
  )
}

export default Progressbar
